import { render, staticRenderFns } from "./contract-detail.vue?vue&type=template&id=83259fb8&scoped=true"
import script from "./contract-detail.vue?vue&type=script&lang=js"
export * from "./contract-detail.vue?vue&type=script&lang=js"
import style0 from "./contract-detail.vue?vue&type=style&index=0&id=83259fb8&prod&scoped=true&lang=css"
import style1 from "./contract-detail.vue?vue&type=style&index=1&id=83259fb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83259fb8",
  null
  
)

export default component.exports